import { Download } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ResultAsset } from "@/lib/types";
import { useLightboxStore } from "@/stores/ui";

// Result card (2026-05-15 redesign): image first, no aspect-crop, single
// prominent "下载原图" CTA below the image. The previous 6-emoji floating
// overlay was removed because users mistook it for a 3rd-party widget and
// the only action that mattered was download.

interface ResultCardProps {
  asset: ResultAsset;
  className?: string;
}

export function ResultCard({ asset, className }: ResultCardProps) {
  const open = useLightboxStore((s) => s.show);
  return (
    <article
      className={cn(
        "group flex w-full max-w-[760px] flex-col overflow-hidden rounded-lg border border-border bg-card transition-all hover:border-accent/60 hover:shadow-result-card",
        className,
      )}
    >
      <button
        type="button"
        className="block w-full cursor-zoom-in bg-muted p-0"
        onClick={() => open(asset.file_url)}
        aria-label="点击放大查看"
      >
        <img
          src={asset.thumbnail_url || asset.file_url}
          alt="生成结果图"
          loading="lazy"
          className="block max-h-[72vh] w-full object-contain"
          onError={(e) => {
            const card = (e.currentTarget as HTMLElement).closest("article");
            if (card) (card as HTMLElement).style.display = "none";
          }}
        />
      </button>
      <div className="flex items-center justify-between gap-3 border-t border-border bg-secondary px-3 py-2.5">
        <span className="font-mono text-[11px] text-muted-foreground/70">
          {asset.width} × {asset.height}
        </span>
        <a
          href={asset.file_url}
          download={`${asset.asset_id}.png`}
          target="_blank"
          rel="noopener"
          className="inline-flex items-center gap-1.5 rounded-md bg-accent px-3 py-1.5 text-xs font-medium text-accent-foreground transition-colors hover:bg-accent/90"
        >
          <Download className="h-3.5 w-3.5" />
          下载原图
        </a>
      </div>
    </article>
  );
}
